import React, { Component } from 'react'
export default class HomeContainer extends Component {
    render() {
        return (
            <div className="main_home_container">
                <div className="typewriter">
                    <div className="pc_typing_effect">
                        <h1>Hi! This is Pratik K. Tiwari</h1>
                    </div>
                    <div className="small_screen_typing_effect">
                        <h1>Hi! This is</h1>
                        <h1>Pratik K. Tiwari</h1>
                    </div>
                </div>
                <div className="social_media_handle">
                    <div className="single_social_handle" target="_blank">
                        <a href="https://twitter.com/pratikktiwari">
                            <i className="fa fa-twitter"></i>
                        </a>
                    </div>
                    <div className="single_social_handle">
                        <a href="https://github.com/pratikktiwari" target="_blank">
                            <i className="fa fa-github"></i>
                        </a>
                    </div>
                    <div className="single_social_handle" target="_blank">
                        <a href="https://www.instagram.com/pratikktiwari/">
                            <i className="fa fa-instagram"></i>
                        </a>
                    </div>
                    <div className="single_social_handle">
                        <a href="https://linkedin.com/in/pratikktiwari" target="_blank">
                            <i className="fab fa-linkedin"></i>
                        </a>
                    </div>
                    <div className="single_social_handle">
                        <a href="https://pratiktiwari.com" target="_blank">
                            <i className="fa fa-globe"></i>
                        </a>
                    </div>
                </div>
                <div clasname="main_about_section" style={{ textAlign: 'center' }}>
                    {/* <a href="#" style={{color:"#fff"}}> */}
                    <span onClick={() => this.props.onClickConsole()} style={{ cursor: "pointer" }}>Open Console</span>
                    {/* </a> */}
                </div>
            </div>
        )
    }
}